import React from 'react';
import BrandingFooter from '../common/BrandingFooter';
import Standings from '../Standings/Standings';

export default function GroupStandings({ groups = null, showBranding, competitionLabel }) {
  if (!groups?.length) {
    return (
      <div style={{ background: 'var(--sw-bg)', color: 'var(--sw-text)' }}>
        <div
          className="px-4 py-2 text-xs font-bold uppercase tracking-wide border-b"
          style={{ borderColor: 'var(--sw-border)', color: 'var(--sw-muted)' }}
        >
          {competitionLabel} — Groups
        </div>
        <p className="text-center text-xs py-8" style={{ color: 'var(--sw-muted)' }}>
          No group-stage tables for this competition.
        </p>
        {showBranding && <BrandingFooter />}
      </div>
    );
  }

  return (
    <Standings
      showBranding={showBranding}
      competitionLabel={competitionLabel}
      table={[]}
      groups={groups}
    />
  );
}
